<template>
  <div>
    <div class="mainDiv">
      <div class="leftDiv" v-show="upShow">
        <div class="boxDiv" v-if="box">文件夹：<a :href="'http://jazpan.com/box/' + box.Id" target="_blank">{{
          box.Name
        }}</a>
          <el-link type="danger" icon="el-icon-circle-close" round @click="clearBox()"></el-link>
          <img class="btnQr" src="//static.jazpan.com/img/qrcode.png"
            @click="$refs.qrcoder.show('https://jazpan.com/box/' + box.Id,'https://m.jazpan.com/xcx/qrgoto/box?'+box.Id)" />
        </div>
        <Upload :boxid="boxid" @okfun="getList()" />
      </div>
      <div class="rightDiv" ref="rightDiv" :style="'width:' + upShowRW">
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
          <el-form :inline="true" :model="listQuery">
            <el-form-item>
              <el-button type="info" @click="handleHide">{{ upShow ? '隐藏' : '显示' }}上传面板</el-button>
            </el-form-item>
            <el-form-item>
              <el-input v-model="listQuery.q" placeholder="搜索"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" v-on:click="getList(); getBoxList();">查询</el-button>
              <el-button-group>
                <el-button type="success" v-on:click="$refs.fileSelForm.show(boxid)">添加文件</el-button>
                <el-button type="warning" v-on:click="$refs.boxSelForm.show(boxid)">添加文件夹</el-button>
              </el-button-group>
            </el-form-item>

            <el-form-item style="margin-left: 20px;">
              <!-- <el-link type="primary" href="https://mp.weixin.qq.com/s/NhYs51XBuWYvy9uRDXRBkw"
                target="_blank">上传资料操作指南</el-link> -->
              <el-button type="primary" v-on:click="onKeySortFun">一键排序文件</el-button>
            </el-form-item>
          </el-form>
        </el-col>


        <div class="tips" v-if="tableData.length > 100||boxlistData.length > 100">提示: 文件夹只能显示100个文件，超过的部分将不会显示出来</div>
        <el-table v-if="boxlistData.length > 0" :data="boxlistData" v-loading="boxlistLoading"
          element-loading-text="Loading" border highlight-current-row @sort-change="changeSortFun" ref="boxdataTable">
          <el-table-column label="状态" align="center" width="100px">
            <template>
              <span>正常</span>
            </template>
          </el-table-column>
          <el-table-column label="文件夹" align="left">
            <template slot-scope="{row}">
              <span v-if="row.Status < 1">{{ row.Name }}</span>
              <a :href="'http://jazpan.com/box/' + row.Id" target="_blank" v-else>
                <img class="flicon" src="//static.jazpan.com/img/flbox.png" />
                {{ row.Name }}
              </a>
            </template>
          </el-table-column>
          <el-table-column label="时间" align="center" width="160px">
            <template slot-scope="{row}">
              <span>{{ row.Timestr }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Sort" label="排序" align="center" width="50px">
          </el-table-column>
          <el-table-column label="操作" align="center" width="250px">
            <template slot-scope="{row}">
              <!-- <el-button-group style="margin-bottom:10px" v-if="row.Canedit">
                <el-button size="small" type="primary" @click="inits(row.Xid)">管理文件
                </el-button>
              </el-button-group> -->
              <img class="btnQr" src="//static.jazpan.com/img/qrcode.png"
                @click="$refs.qrcoder.show('https://jazpan.com/box/' + row.Id,'https://m.jazpan.com/xcx/qrgoto/box?'+row.Id)" />
              <el-link type="primary" :underline="false" @click="inits(row.Xid)" class="btnTxt"
                v-if="row.Canedit">管理</el-link>
              <el-link type="primary" :underline="false" @click="$refs.boxSelfForm.show(row)" class="btnTxt">排序</el-link>
              <el-link type="warning" :underline="false" @click="rmBoxFun(row.Prtid, row.Xid)" class="btnTxt">移除</el-link>
              <!-- <el-button-group>
                <el-button size="small" type="info" @click="$refs.boxSelfForm.show(row)">修改信息</el-button>
                <el-button size="small" type="warning" @click="rmBoxFun(row.Prtid, row.Xid)">移除文件夹</el-button>
              </el-button-group> -->
            </template>
          </el-table-column>
        </el-table>


        <el-table :data="tableData" v-loading="listLoading" element-loading-text="Loading" border highlight-current-row
          @sort-change="changeSortFun" ref="dataTable" style="margin-top:20px">
          <el-table-column label="状态" align="center" width="100px">
            <template slot-scope="{row}">
              <span>{{ row.Stats }}</span>
            </template>
          </el-table-column>
          <el-table-column label="文件名" align="left">
            <template slot-scope="{row}">
              <span v-if="row.Status < 1">{{ row.Name }}</span>
              <a :href="'http://jazpan.com/view/' + row.Id" target="_blank" v-else>
                <img class="flicon" :src="$ApiUrl + '/icon?name=' + row.Extion" />
                {{ row.Name }}
              </a>
            </template>
          </el-table-column>
          <el-table-column label="金额" align="center" width="100px">
            <template slot-scope="{row}">
              <span style="color:#f60;font-weight:bold">{{ row.Amounts }}</span>
            </template>
          </el-table-column>
          <el-table-column label="大小" align="center" width="120px">
            <template slot-scope="{row}">
              <span>{{ getFlSize(row.Size) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Downs" label="下载" align="center" width="80px" sortable>
          </el-table-column>
          <el-table-column label="时间" align="center" width="160px">
            <template slot-scope="{row}">
              <span>{{ row.Timestr }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Sort" label="排序" align="center" width="50px">
          </el-table-column>
          <el-table-column label="操作" align="center" width="250px">
            <template slot-scope="{row}">
              <!-- <el-button-group style="margin-bottom:10px" v-if="row.Canedit">
                <el-button size="small" type="primary" @click="$refs.fileEdit.show(row)">编辑</el-button>
                <el-button size="small" type="danger" @click="delFun(row.Xid)">删除</el-button>
              </el-button-group> -->
              <img class="btnQr" src="//static.jazpan.com/img/qrcode.png"
                @click="$refs.qrcoder.show('https://jazpan.com/view/' + row.Id,'https://m.jazpan.com/xcx/qrgoto/file?'+row.Id)" />
              <i class="btnQr el-icon-edit-outline" style="color:#db3939" @click="$refs.fileEdit.show(row)"
                v-if="row.Canedit"></i>
              <i class="btnQr el-icon-delete" style="color:#db3939" @click="delFun(row.Xid)" v-if="row.Canedit"></i>
              <el-link type="primary" :underline="false" @click="$refs.boxflEdit.show(row)" class="btnTxt">排序</el-link>
              <el-link type="warning" :underline="false" @click="rmFun(row.Boxid, row.Xid)" class="btnTxt">移除</el-link>
              <!-- <el-button-group>
                <el-button size="small" type="info" @click="$refs.boxflEdit.show(row)">修改信息</el-button>
                <el-button size="small" type="warning" @click="rmFun(row.Boxid, row.Xid)">移除文件夹</el-button>
              </el-button-group> -->
            </template>
          </el-table-column>
        </el-table>

        <div style="text-align:right;margin-top:50px;">
          <!-- <el-pagination
            background
            layout="prev, pager, next"
            @current-change="getList"
            :current-page="pgpage"
            :page-count="pgpages">
            </el-pagination> -->
        </div>
      </div>
      <FileEdit ref="fileEdit" @submitOK="getList()" />
      <BoxFileForm ref="boxflEdit" @submitOK="getList()" />
      <BoxSelfForm ref="boxSelfForm" @submitOK="getBoxList()" />
      <FileSelForm ref="fileSelForm" @submitOK="getList()" />
      <BoxSelForm ref="boxSelForm" @submitOK="getBoxList()" />
      <Qrcode ref="qrcoder" />
    </div>
  </div>
</template>

<script>
import util from '@/common/js/util'
import FileEdit from './FileEdit';
import BoxFileForm from './BoxFileForm';
import BoxSelfForm from './BoxSelfForm';
import FileSelForm from './FileSelForm';
import BoxSelForm from './BoxSelForm';
import Qrcode from './Qrcode';
import Upload from './Upload';
export default {
  components: { FileEdit, BoxFileForm, BoxSelfForm, FileSelForm, BoxSelForm, Qrcode, Upload },
  data () {
    return {
      boxid: '',
      box: null,
      upShow: true,
      upShowRW: 'auto',
      listLoading: false,
      listQuery: {
        q: '',
      },
      tableData: [],
      boxlistData: [],
      boxlistLoading: false,
    }
  }, mounted () {
    this.inits();
  }, methods: {
    getFlSize: util.getFlSize,
    inits (bid) {
      this.boxid = this.$route.query.boxid;
      if (bid) {
        this.$router.push('/file/boxfls?boxid=' + bid)
        this.boxid = bid;
      }
      if (this.boxid == null || this.boxid == '') {
        this.clearBox();
        return;
      }
      this.getBox();
      this.getList();
      this.getBoxList();
      this.upShowRW = this.$refs.rightDiv.clientWidth + 'px';
    },
    clearBox () {
      this.$router.push('/file/fls');
      /*setTimeout(()=>{
          window.location.reload();
      },1000);*/
    }, getBox () {
      this.$post('/user/box', { xid: this.boxid }).then(res => {
        this.box = res.data;
      }).catch(err => {
        this.clearBox();
      });
    }, getList () {
      this.listLoading = true;
      this.listQuery.boxid = this.boxid;
      this.$post('/user/boxfls', this.listQuery).then(res => {
        console.log('fls:', res);
        this.listLoading = false;
        this.tableData = res.data;
        // this.$message('退出成功');
      }).catch(err => {
        this.listLoading = false;
        this.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    }, getBoxList () {
      this.boxlistLoading = true;
      this.listQuery.boxid = this.boxid;
      this.$post('/user/boxselfs', this.listQuery).then(res => {
        this.boxlistLoading = false;
        this.boxlistData = res.data;
        // this.$message('退出成功');
      }).catch(err => {
        this.boxlistLoading = false;
        this.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    }, onKeySortFun () {
      this.$confirm('确定要按文件名排序所有文件吗? (最好开头有数字，不包括文件夹)', '提示', {
        type: 'warning'
      }).then(() => {
        this.$post('/user/box/flsorts', { boxid: this.boxid }).then(res => {
          this.$message('排序成功');
          this.getList();
        }).catch(err => {
          this.$message({
            message: err.response ? err.response.data || '服务器错误' : '网络错误',
            type: 'error'
          });
        });
      });
    }, delFun (xid) {
      this.$confirm('确定要永久删除此文件吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.$post('/user/fldel', { xid: xid }).then(res => {
          this.$message('删除成功');
          this.getList();
        }).catch(err => {
          this.$message({
            message: err.response ? err.response.data || '服务器错误' : '网络错误',
            type: 'error'
          });
        });
      });
    }, rmFun (bid, xid) {
      this.$confirm('确定要把文件从文件夹移除吗?\n只是移除该文件夹(不会删除)', '提示', {
        type: 'warning'
      }).then(() => {
        this.$post('/user/boxinform', { boxid: bid, xid: xid }).then(res => {
          this.$message('移除成功');
          this.getList();
        }).catch(err => {
          this.$message({
            message: err.response ? err.response.data || '服务器错误' : '网络错误',
            type: 'error'
          });
        });
      });
    }, rmBoxFun (bid, xid) {
      this.$confirm('确定要把文件夹从文件夹移除吗?\n只是移除该文件夹(不会删除)', '提示', {
        type: 'warning'
      }).then(() => {
        this.$post('/user/boxinforms', { boxid: bid, xid: xid }).then(res => {
          this.$message('移除成功');
          this.getBoxList();
        }).catch(err => {
          this.$message({
            message: err.response ? err.response.data || '服务器错误' : '网络错误',
            type: 'error'
          });
        });
      });
    }, handleHide () {
      this.upShow = !this.upShow;
      this.$refs.dataTable.doLayout();
      this.$refs.boxdataTable.doLayout();
    }, changeSortFun (e) {
      console.log('changeSortFun:', e);
      if (e.order) {
        this.listQuery.sort = {};
        this.listQuery.sort[e.prop] = e.order == "ascending" ? 1 : 2
      } else {
        this.listQuery.sort = null;
      }
      this.getList();
    }
  }
}
</script>

<style scoped lang="scss">
.tips{
  padding:5px;
  color:red;
  font-size: 12px;
}
.mainDiv {
  display: flex;
  margin-top: 20px;
  clear: both;

  .leftDiv {
    width: 350px;
    margin-top: 30px;
    margin-right: 40px;

    .boxDiv {
      text-align: center;
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;

      a {
        color: blue;
        margin-right: 10px;
      }
    }
  }

  .rightDiv {
    flex: 1;
  }
}
</style>


// WEBPACK FOOTER //
// BoxFileList.vue?51c4c22e